/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Tenant Edge API (DEV)
 * Live API Gateway routes, documented from backend contracts/rest.
 * OpenAPI spec version: live
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  IdentityChangePasswordRequest,
  ProblemDetails
} from '../../models';

import { apiMutator } from '../../../http/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Changes the caller's password through Cognito `ChangePassword`. **Any authenticated caller, for themselves only**: the user is the bearer token's owner; the body names no user.
 * @summary Change the caller's own password
 */
export const changeOwnPassword = (
    identityChangePasswordRequest: IdentityChangePasswordRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/v1/identity/me/change-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityChangePasswordRequest, signal
    },
      options);
    }




export const getChangeOwnPasswordMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeOwnPassword>>, TError,{data: IdentityChangePasswordRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof changeOwnPassword>>, TError,{data: IdentityChangePasswordRequest}, TContext> => {

const mutationKey = ['changeOwnPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeOwnPassword>>, {data: IdentityChangePasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  changeOwnPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeOwnPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changeOwnPassword>>>
    export type ChangeOwnPasswordMutationBody = IdentityChangePasswordRequest
    export type ChangeOwnPasswordMutationError = ProblemDetails

    /**
 * @summary Change the caller's own password
 */
export const useChangeOwnPassword = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeOwnPassword>>, TError,{data: IdentityChangePasswordRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeOwnPassword>>,
        TError,
        {data: IdentityChangePasswordRequest},
        TContext
      > => {
      return useMutation(getChangeOwnPasswordMutationOptions(options), queryClient);
    }
